'use strict';

export class ProfileEditCtrl
{
	initialized = false;
	progress = false;
	submitted = false;
	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	
	passResetUrl;
	flow;
	dragClass = '';
	postData = {
		newpass_repeat: '',
		newpass: ''
	};

	
	constructor($scope, $filter, $http, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
	}
	
	$onInit(){
		this.initialized = true;
	}
	
	actionStore(){
		const url = this.jsDataService.get('passResetUrl');
		if(url){
			this.submitted = true;
			this.progress = true;
			this.$http({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: this.postData
			}).then(response => {
				this.progress = false;
				this.postData = {
					newpass_repeat: '',
					newpass: ''
				};
				if(response.data){
					if(response.data.success){
						if(typeof(response.data.url) !== 'undefined'){
							window.location.href = response.data.url;
						}
						else{
							this.submitted = false;
						}

					}
					else{
						this.submitted = false;
					}
					if(response.data.message){
						this.notify(response.data.message, !response.data.success);
					}
				}
				else{
					this.submitted = false;
					console.log(response);
					this.notify('Communication Error', true);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
				this.notify('Network error, Status: ' + response.status, true);
				this.progress = false;
				this.submitted = false;
			});
		}
	}
	

}

